import { Component } from '@angular/core';
import { AuthSelectors, SessionSelectors } from '@store';
import { Ferie, HolidayView } from '@store/models';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HolidayService } from './holiday.service';

@Component({
    selector: 'app-holiday-modal',
    template: `
        <app-holiday-modal-ui
            [userLevel]="userLevel$ | async"
            [selectedYear]="year"
            [users]="users$ | async"
            [holidays]="holidays$ | async"
            (selectYear)="selectYear($event)"
            (saveFerie)="saveFerie($event)"
        ></app-holiday-modal-ui>
    `,
    standalone: false
})
export class HolidayModalContainerComponent {
    userLevel$ = this.authSelector.userLev$;
    year = new Date().getFullYear();
    users$ = this.sessionSelector.users$(new Date());
    holidaysSubject$ = new BehaviorSubject<HolidayView[]>([]);
    holidays$ = this.holidaysSubject$.asObservable();

    constructor(
        private authSelector: AuthSelectors,
        private sessionSelector: SessionSelectors,
        private holidayService: HolidayService
    ) {
        this.getHolidays();
    }

    selectYear(year: number) {
        this.year = year;
        this.holidays$ = this.holidayService.getHolidays(year);
    }

    getHolidays() {
        this.holidayService.getHolidays(this.year).pipe(
            tap(holidays => this.holidaysSubject$.next(holidays))
        ).subscribe();
    }

    saveFerie(ferie: Ferie) {
        this.holidayService.saveFerie(ferie).pipe(
            tap(() => this.getHolidays())
        ).subscribe();
    }

}
